import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-toaster-notifications',
  templateUrl: './toaster-notifications.component.html',
  styleUrls: ['./toaster-notifications.component.scss'],
  imports: [NgClass, MatIcon]
})
export class ToasterNotificationsComponent implements OnChanges, OnDestroy {
  @Input() type!: 'success' | 'error' | 'warning';
  @Input() message!: string;
  @Input() class: string = "";
  visible: boolean = false;
  private hideTimeoutId: any;

  ngOnChanges(changes: SimpleChanges) {
    // `app.component.html` keeps this component mounted, so we toggle visibility
    // whenever `message` changes to a non-empty value.
    const messageChanged = !!changes['message'];
    const hasMessage = typeof this.message === 'string' && this.message.trim().length > 0;

    if (messageChanged && hasMessage) {
      this.visible = true;
      if (this.hideTimeoutId) {
        clearTimeout(this.hideTimeoutId);
      }
      this.hideTimeoutId = setTimeout(() => {
        this.visible = false;
      }, 3000);
    }

    if (messageChanged && !hasMessage) {
      this.visible = false;
      if (this.hideTimeoutId) {
        clearTimeout(this.hideTimeoutId);
      }
    }
  }

  close() {
    this.visible = false;
    if (this.hideTimeoutId) {
      clearTimeout(this.hideTimeoutId);
    }
  }

  ngOnDestroy() {
    if (this.hideTimeoutId) {
      clearTimeout(this.hideTimeoutId);
    }
  }
}
